import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
export default class Contact {
    constructor() {
        
        this.form = document.querySelector('#formContact')
        this.btnSubmit = this.form.querySelector('button')

		this.contactError = document.querySelector('.contactError')
		this.contactSuccess = document.querySelector('.contactSuccess')

		this.recaptchaError = document.querySelector('.recpatcha-error')

        this.ready();
    }

	ready() {
		new Bouncer(`#formContact`, {
			fieldClass: 'error-field',
			disableSubmit: true,
			// ...Forms.wrongMessages(),
		})

		this.btnSubmit.addEventListener('click', () => {
			let response = grecaptcha.getResponse()
			console.log('response recpatcha', response)
		})

		this.form.addEventListener(
			'bouncerFormValid',
			(event) => {
				event.preventDefault()
				if (event.target.id == this.form.id) {
					this.sendFormContactAjax(event.target)
				}
			},
			false
		)
	}


	sendFormContactAjax(form) {

		let response = grecaptcha.getResponse()
		if(response != '') {
			this.recaptchaError.classList.add('hidden')
			this.btnSubmit.disabled = true
			const dataForm = new FormData(form)
	
			if (document.querySelector('#polices').checked) {
				dataForm.set('polices', 1);
			} else {
				dataForm.set('polices', 0);
			}
	
			const data = this.formDataToQueryString(dataForm);
	
			axios({
				method: 'POST',
				url: window.location.protocol+"//"+window.location.hostname+'/lp-inscriptions-usa',
				data: data,
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			})
				.then(() => {
					this.btnSubmit.disabled = false
					this.contactError.classList.add('hidden')
					this.contactSuccess.classList.remove('hidden')
					document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
					form.reset();
				})
				.catch(() => {
					console.log('Erro')
					this.btnSubmit.disabled = false
					this.contactSuccess.classList.add('hidden')
					this.contactError.classList.remove('hidden')
				})
		} else {
			this.recaptchaError.classList.remove('hidden')
		}

	}

	formDataToQueryString(formData) {
		const params = new URLSearchParams();
		for (const pair of formData.entries()) {
			params.append(pair[0], pair[1]);
		}
		return params.toString();
	}
    


}